import { getStyledElement } from "@/helpers";

export const Divider = getStyledElement("hr")({
  styles: ({ theme }) => ({
    borderTop: `2px solid ${theme.colors.primaryPrx}`
  })
});
